import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxBaseUiOptions} from "../dx-base-ui-options";

/**
 * Класс опций элемента шапки страницы.
 * @publicApi
 */
@jsonObject
export class DxPageHeaderItemOptions extends DxBaseUiOptions {
  /**
   * Строковый идент элемента шапки страницы.
   * @name _ident
   * @type {string}
   */
  @jsonMember({name: "ident", constructor: String, emitDefaultValue: true, isRequired: false})
  private _ident: string;

  /**
   * Тип элемента шапки страницы.
   * @name _type
   * @type {string}
   */
  @jsonMember({name: "type", constructor: String, emitDefaultValue: true, isRequired: false})
  private _type: string;

  /**
   * Относительный путь до иконки элемента шапки страницы.
   * @name _iconPath
   * @type {string}
   */
  @jsonMember({name: "iconPath", constructor: String, emitDefaultValue: true, isRequired: false})
  private _iconPath: string;

  /**
   * Иконка элемента шапки страницы, свернутая в base64.
   * @name _iconBase64
   * @type {string}
   */
  @jsonMember({name: "iconBase64", constructor: String, emitDefaultValue: true, isRequired: false})
  private _iconBase64: string;

  /**
   * Порядок следования элемента шапки страницы.
   * @name _ord
   * @type {number}
   * @defaultValue - 0
   */
  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _ord: number = 0;

  /**
   * Многострочное название виджета.
   * @name _multiLineTitle
   * @type {string[]}
   */
  @jsonArrayMember(String, {name: "multiLineTitle", emitDefaultValue: true, isRequired: false})
  private _multiLineTitle: string[];

  /**
   * Флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
   * @name _addSeparatorAfter
   * @type {boolean}
   * @defaultValue - `false`
   */
  @jsonMember({name: "addSeparatorAfter", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _addSeparatorAfter: boolean = false;

  /**
   * Возвращает cтроковый идент элемента шапки страницы.
   * @return {string} - cтроковый идент элемента шапки страницы.
   * @public
   */
  get ident(): string {
    return this._ident;
  }

  /**
   * Устанавливает cтроковый идент элемента шапки страницы.
   * @param {string} value - cтроковый идент элемента шапки страницы.
   * @public
   */
  set ident(value: string) {
    this._ident = value;
  }

  /**
   * Возвращает тип элемента шапки страницы.
   * @return {string} - cтроковый идент элемента шапки страницы.
   * @public
   */
  get type(): string {
    return this._type;
  }

  /**
   * Устанавливает тип элемента шапки страницы.
   * @param {string} value - типа элемента шапки страницы.
   * @public
   */
  set type(value: string) {
    this._type = value;
  }

  /**
   * Возвращает относительный путь до иконки элемента шапки страницы.
   * @return {string} - относительный путь до иконки элемента шапки страницы.
   * @public
   */
  get iconPath(): string {
    return this._iconPath;
  }

  /**
   * Устанавливает относительный путь до иконки элемента шапки страницы.
   * @param {string} value - относительный путь до иконки элемента шапки страницы.
   * @public
   */
  set iconPath(value: string) {
    this._iconPath = value;
  }

  /**
   * Возвращает иконку элемента шапки страницы, свернутую в base64.
   * @return {string} - иконка элемента шапки страницы, свернутая в base64.
   * @public
   */
  get iconBase64(): string {
    return this._iconBase64;
  }

  /**
   * Устанавливает иконку элемента шапки страницы, свернутую в base64.
   * @param {string} value - иконка элемента шапки страницы, свернутая в base64.
   * @public
   */
  set iconBase64(value: string) {
    this._iconBase64 = value;
  }

  /**
   * Возвращает порядок следования элемента шапки страницы.
   * @return {number} - порядок следования элемента шапки страницы.
   * @public
   */
  get ord(): number {
    return this._ord;
  }

  /**
   * Устанавливает порядок следования элемента шапки страницы.
   * @param {string} value - порядок следования элемента шапки страницы.
   * @public
   */
  set ord(value: number) {
    this._ord = value;
  }

  /**
   * Возвращает многострочное название виджета.
   * @return {string[]} - массив частями названия виджета, которые нужно вывести построково.
   * @public
   */
  get multiLineTitle(): string[] {
    return this._multiLineTitle;
  }

  /**
   * Устанавливает многострочное название виджета.
   * @param {string[]} value - массив частями названия виджета, которые нужно вывести построково.
   * @public
   */
  set multiLineTitle(value: string[]) {
    this._multiLineTitle = value;
  }

  /**
   * Возвращает флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
   * @return {boolean} - флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
   * @public
   */
  get addSeparatorAfter(): boolean {
    return this._addSeparatorAfter;
  }

  /**
   * Устанавливает флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
   * @param {string} value - флаг добавлять \ не добавлять элемент-сператор после данного элемента шапки.
   * @public
   */
  set addSeparatorAfter(value: boolean) {
    this._addSeparatorAfter = value;
  }
}
